import { getReceiptCurrLS } from "../utils/main-utils";
import api from "./api";

export interface SaleSpecification {
  isComponent: boolean;
  specificationId: number;
  extraCharge: number;
  quantity: number;
  notes: string;
}

export interface SaleDetail {
  barcode: string;
  quantity: number;
  cost: number;
  price: number;
  isTaxable: boolean;
  tax: number;
  discount: number | null;
  notes: string | null;
  specifications: SaleSpecification[];
}
type Receipt = {
  paymentModeId: number;
  date: Date | null;
  dueDate: Date | null;
  reference: string;
  amount: number;
  currencyId: number;
  exchangeRate: number;
  isPosted: boolean;
  postedDate: Date | null;
  notes: string | null;
};

export interface Sale {
  id: number;
  warehouseId: number;
  sessionId: number;
  workstationId: number;
  customerId: number | null;
  paymentModeId: number;
  invoiceTypeId: number;
  date: string;
  dueDate: string;
  isTaxable: boolean;
  tax: number | null;
  onHold: boolean;
  discountType: string;
  discount: number;
  currencyId: number;
  exchangeRate: number;
  taxExchangeRate: number | null;
  isApproved: boolean;
  approvedDate: string | null;
  isDelivered: boolean;
  deliveredDate: string | null;
  isPaid: boolean;
  paidDate: string | null;
  isPosted: boolean;
  postedDate: string | null;
  notes: string | null;
  details: SaleDetail[];
}
export interface ReceiptAndSale {
  warehouseId: number;
  sessionId: number;
  workstationId: number;
  customerId: number | null;
  paymentModeId: number;
  invoiceTypeId: number;
  date: string;
  dueDate: string;
  isTaxable: boolean;
  tax: number | null;
  onHold: boolean;
  discountType: string;
  discount: number;
  currencyId: number;
  exchangeRate: number;
  taxExchangeRate: number | null;
  isApproved: boolean;
  approvedDate: string | null;
  isDelivered: boolean;
  deliveredDate: string | null;
  isPaid: boolean;
  paidDate: string | null;
  isPosted: boolean;
  postedDate: string | null;
  notes: string | null;
  details: SaleDetail[];
  receipts: Receipt[];
}

export const createSale = async (body: Sale) => {
  return await api.post("/sales", body);
};
export const createReceipt = async (body: ReceiptAndSale) => {
  return await api.post("/sales/receipts", body);
};
export const getOnHoldSales = async (limit: number, q: string) => {
  const sessionId = localStorage.getItem("sessionId");
  return await api.get(
    `/sales/onHoldSale/session/${sessionId}?limit=${limit}&q=${q}`
  );
};



export const getSaleById = async (id: number | null) => {
  let url = `/sales/${id}`
  if(getReceiptCurrLS() === "lbp"){
    url += `?hasLebanesePound=true`;
  }
  return await api.get(url);
};



export const restoreSale = async (id: number | null) => {
  return await api.put(`/sales/${id}/restore`);
};
export const deleteSale = async (id: number | null) => {
  return await api.delete(`/sales/${id}`);
};
export const deleteSaleReturn = async (id: number | null) => {
  return await api.delete(`/sales-returns/${id}`);
};

/*Search & date filter */
export const getSalesApi = async (body: {
  limit: number;
  q: string;
  from: string;
  to: string;
  isPaid?: boolean;
}) => {
  let url = `/sales?limit=${body.limit}&q=${body.q.toString()}&from=${body.from
    }&to=${body.to}`;

  if (body.isPaid !== undefined) {
    url += `&isPaid=${body.isPaid}`;
  }

  return await api.get(url);
};

export const getSale = async (body: {
  session: number | string | undefined;
  limit: number;
  isPaid?: boolean;
  q: string;
}) => {
  let url = `/sales/session/${body.session}?limit=${body.limit}&q=${body.q}`;
  if (body.isPaid !== undefined) {
    url += `&isPaid=${body.isPaid}`;
  }
  return await api.get(url);
};
